import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card, Button } from 'react-bootstrap';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { DashboardOutlined } from '@material-ui/icons';
import ListingReportsCompanyWithUsers from 'components/ListingReportsCompanyWithUsers';
import MasterPage from 'components/MasterPage';
import { api } from 'services';

const CompanyWithUsers = () => {
  const defaultFilters = { search: '', per_page: 10, page: 1, profile: '' };
  const [filters, setFilters] = useState(defaultFilters);
  const [reports, setReports] = useState({ data: [], data_export: [] });
  const [fiscalYears, setFiscalYears] = useState([]);
  const [periodTypes, setPeriodTypes] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    var btn_export = document.getElementById('btn-to-excel');
    if (btn_export != null) {
      btn_export.disabled = true;
    }
    api.get('companies/with-users', { params: { ...filters } }).then(({ data }) => setReports(data));
  }, [filters]);

  const handleFilterChange = (new_filters, reset = false) => {

    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  return (
    <>
      <Card.Body className="shadow bg-white rounded mb-3">
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">Fabricantes com Usuários Responsáveis</h4>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Row>
              <Col>
                <ReactHTMLTableToExcel
                  id="btn-to-excel"
                  className="login-btn mr-1 btn btn-primary-login btn-sm"
                  sheet="Report Vendors with Users"
                  filename="Report Vendors with Users"
                  table="table-to-xls"
                  buttonText={t('label:export')}
                ></ReactHTMLTableToExcel>
              </Col>
            </Row>
            <Row className="mt-5">
              <Col>
                <ListingReportsCompanyWithUsers
                  reports={reports}
                  filters={[]}
                  stateFilters={filters}
                  setFilters={setFilters}
                  handleFilterChange={handleFilterChange}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </>
  );
};

export default MasterPage(CompanyWithUsers);
